import { off } from 'onyx-common/emitter'

export default off
